import type { RendererProps } from "../types";

export function TextRenderer({ content }: RendererProps) {
  return (
    <div className="whitespace-pre-wrap break-words text-[15px] leading-relaxed text-foreground/90 selection:bg-primary/20">
      {content.displayPreview || <span className="italic text-muted-foreground">Empty</span>}
    </div>
  );
}
